import React, { useEffect } from 'react';
import {
	makeStyles,
	Box,
	Grid,
	MenuItem,
	TextField as TextField2,
} from '@material-ui/core';
import { Field, Form, Formik, FieldArray, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { TextField } from 'formik-material-ui';
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid lightslategrey',
			},
		},
		// backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 5,
		// border: '1px solid lightslategrey',

		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			color: 'white',
		},
	},
	InputPropsStyle: {
		backgroundColor: 'rgb(14, 30, 44)',
		borderRadius: 15,
		border: '1px solid lightslategrey',
	},
	inputPropsStyle: {
		padding: 14,
		border: '1px solid lightslategrey',
	},
	createButton: {
		backgroundColor: 'yellow',
		// color: '',
		borderRadius: 5,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: 'rgb(239, 51, 57)',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	date: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
			width: '100%',
		},
	},
	dob: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	passport: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	root: {
		'& .MuiFormHelperText-root': {
			fontSize: 12,
		},
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& label': {
			fontSize: 15,
			colo: 'white',
		},
		// '& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
		// 	fontSize: 14,
		// },
	},
	root2: {
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& label': {
			fontSize: 15,
		},
	},
}));
const SubscribeForm = () => {
	const classes = useStyles();
	const handleFormSubmit = (data) => {
		console.log('Data', data);
	};

	return (
		<>
			<Formik
				initialValues={{
					fullname: '',
					phone: '',
					email: '',
				}}
				validationSchema={Yup.object({
					phone: Yup.string()
						.required('Phone required')
						.min(10, 'too short')
						.max(10, 'too long'),
					email: Yup.string()
						.required('email required')
						.email('Enter valid email'),
					fullname: Yup.string().required('fullname required'),
				})}
				onSubmit={handleFormSubmit}>
				{(formik) => (
					<Form>
						<Grid
							container
							spacing={2}
							alignItems='center'
							style={{ marginTop: 20, alignItems: 'baseline' }}>
							<Grid item xs={12} lg={5}>
								<Field
									component={TextField}
									name='fullname'
									type='text'
									variant='outlined'
									// error={errors.email}
									label='Full Name'
									className={classes.selectField}
									InputProps={{
										className: classes.InputPropsStyle,
									}}
									inputProps={{
										style: { padding: 12 },
									}}
								/>
							</Grid>
							<Grid item xs={12} lg={5}>
								<Field
									component={TextField}
									name='phone'
									type='number'
									variant='outlined'
									// error={errors.phone}
									label='Mobile No.'
									className={classes.selectField}
									InputProps={{
										className: classes.InputPropsStyle,
									}}
									inputProps={{
										style: { padding: 12 },
									}}
								/>
							</Grid>
						</Grid>

						<Grid
							container
							spacing={2}
							alignItems='center'
							style={{ marginBottom: 20 }}>
							<Grid item xs={12} lg={5}>
								<Field
									component={TextField}
									name='email'
									type='email'
									variant='outlined'
									// error={errors.email}
									label='Email ID'
									className={classes.selectField}
									InputProps={{
										className: classes.InputPropsStyle,
									}}
									inputProps={{
										style: { padding: 12 },
									}}
								/>
							</Grid>
							<Grid item xs={12} lg={5}>
								<button
									type='submit'
									className={classes.createButton}
									style={{ fontSize: 16, cursor: 'pointer' }}>
									Subscribe
								</button>
							</Grid>
							<Grid item xs={4}></Grid>
						</Grid>
					</Form>
				)}
			</Formik>
		</>
	);
};

export default SubscribeForm;
